import type { CityConfig } from "../city-template/types";

export const laCrosseConfig: CityConfig = {
  city: "La Crosse",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "la-crosse",
  route: "/la-crosse",
  title: "Emergency Passport La Crosse, WI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in La Crosse, Wisconsin — as fast as 24 hours. Fast passport renewal and new passport applications for La Crosse, Onalaska, Holmen, and all Coulee Region residents. A+ BBB rated registered courier with access to Chicago Passport Agency.",
  h1: "Emergency & Expedited Passport Services in La Crosse, WI",
  heroSubtitle: "La Crosse and the Coulee Region have no local passport agency — the nearest is Chicago, about 300 miles southeast. Fast Passport Center's registered couriers deliver your documents directly to the Chicago Passport Agency, getting you a new or renewed passport as fast as 24–48 hours without the nearly 10-hour roundtrip drive.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=La%20Crosse%20Wisconsin%20downtown%20skyline%20along%20the%20Mississippi%20River%20with%20historic%20Riverside%20Park%20and%20the%20iconic%20Cass%20Street%20bridge%2C%20Grandad%20Bluff%20rising%20dramatically%20in%20the%20background%20with%20panoramic%20views%20of%20the%20river%20valley%2C%20vibrant%20autumn%20colors%20with%20gold%20and%20crimson%20foliage%20across%20the%20bluffs%2C%20warm%20golden%20afternoon%20light%20reflecting%20on%20the%20Mississippi%2C%20professional%20landscape%20photography%20with%20rich%20natural%20tones%2C%20classic%20Midwestern%20river%20city%20scenery%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20and%20nature%20photography&width=1800&height=700&seq=la-crosse-wi-hero-001&orientation=landscape",
  heroImageAlt: "La Crosse Wisconsin downtown along Mississippi River with Grandad Bluff in background",
  geoPosition: "43.8014;-91.2396",
  geoPlacename: "La Crosse, Wisconsin",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 300 miles from La Crosse — about 5 hours via I-90 southeast",
  },
  nearbyCitiesZips: [
    { name: "Downtown La Crosse", zips: "54601, 54602, 54603" },
    { name: "Onalaska", zips: "54650" },
    { name: "Holmen", zips: "54636" },
    { name: "West Salem", zips: "54669" },
    { name: "Sparta", zips: "54656" },
    { name: "Tomah", zips: "54660" },
    { name: "Viroqua", zips: "54665" },
    { name: "Prairie du Chien", zips: "53821" },
    { name: "Arcadia", zips: "54612" },
    { name: "Winona, MN", zips: "55987" },
    { name: "Caledonia, MN", zips: "55921" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — no 10-hour roundtrip from La Crosse required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for the Coulee Region" },
    { icon: "ri-building-line", title: "Coulee Region Hub", desc: "Serving La Crosse, Onalaska, Holmen, and all western Wisconsin" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx location in the La Crosse area" },
  ],
  internalLinks: [
    { name: "Expedited passport in Eau Claire, WI", route: "/eau-claire" },
    { name: "Emergency passport help in Wausau, WI", route: "/wausau" },
    { name: "Urgent passport services in Madison, WI", route: "/madison-wi" },
    { name: "Wisconsin passport services overview", route: "/wisconsin" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves La Crosse, Wisconsin via secure registered courier to the Chicago Passport Agency (230 S Dearborn St, Chicago). Approximately 300 miles — about a 5-hour drive via I-90. La Crosse's position on the Mississippi River with direct I-90 access makes overnight shipping reliable. We handle the Chicago drive so La Crosse and Coulee Region residents never need to navigate downtown Chicago traffic.",
  fpcOfficeDistance: "Serving La Crosse, Onalaska, Holmen, West Salem, Sparta, Tomah, Viroqua, Prairie du Chien, Arcadia, and all Coulee Region communities in western Wisconsin",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout La Crosse and the Coulee Region. From the historic downtown riverfront and Grandad Bluff area to surrounding communities like Onalaska, Holmen, and Sparta — we serve all of western Wisconsin with direct courier access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve La Crosse and all nearby Coulee Region communities including Onalaska, Holmen, West Salem, Sparta, Tomah, Viroqua, Prairie du Chien, and Arcadia. La Crosse's position as the largest city on the Wisconsin side of the Mississippi River north of Dubuque makes it the natural hub for expedited passport services in the region.",
  howItWorksIntro: "Most La Crosse travelers — especially UW-La Crosse students, Coulee Region professionals, and Mississippi River valley families — complete everything online and ship documents via overnight courier from any UPS or FedEx in the La Crosse area. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "La Crosse is a vibrant Mississippi River city with a strong university community and international connections — but being 300 miles from the nearest passport agency creates unique challenges. Here are the most common mistakes we see from Coulee Region travelers.",
  testimonialsIntro: "La Crosse travelers — from UW-La Crosse students and faculty to Coulee Region families to Mississippi River valley professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in La Crosse, WI? Here are the most common ones we hear from Coulee Region and western Wisconsin travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  dmvWebsite: "https://www.dot.wisconsin.gov/drivers",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Agency courier — no 10-hour drive", "Predictable turnaround for Coulee Region travelers", "Ideal for LSE Airport departures", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service USPS", "Good for planned travel from LSE or MSP", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Drive 300 miles to Chicago Passport Agency", "Nearly 10-hour roundtrip from La Crosse"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For La Crosse travelers with flights within 72 hours — our couriers hand-deliver to Chicago Passport Agency, as fast as 24 hours. Skip the 10-hour roundtrip drive.",
      bullets: ["24–48 hour turnaround available", "No 10-hour roundtrip to Chicago", "Coulee Region's fastest passport option"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for La Crosse adults with a passport issued within the last 15 years. Ideal for UW-La Crosse faculty and Coulee Region professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Serving all of La Crosse County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for La Crosse residents, Coulee Region families, and UW-La Crosse students heading abroad.",
      bullets: ["Acceptance facility scheduling near campus", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for La Crosse residents — whether lost on campus, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for La Crosse and Coulee Region families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for La Crosse and western Wisconsin residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport La Crosse WI", description: "Urgent passport processing for La Crosse Wisconsin travelers via Chicago Passport Agency courier." },
    { name: "Expedited Passport Renewal La Crosse WI", description: "Fast passport renewal for La Crosse and Coulee Region Wisconsin residents." },
    { name: "First-Time Passport La Crosse WI", description: "New passport application services for La Crosse Wisconsin residents and UW-La Crosse students." },
    { name: "Child Passport La Crosse WI", description: "Minor passport services for La Crosse Wisconsin families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jessica T.",
      location: "La Crosse, WI — Near UW-La Crosse Campus",
      rating: 5,
      text: "Study abroad program in Barcelona starting in 7 days. Discovered my passport was expired during move-in week. Fast Passport Center got me renewed in 3 days. Shipped from the UPS Store near campus and made it in time. Lifesaver for Eagles!",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Brian K.",
      location: "Onalaska, WI",
      rating: 5,
      text: "Business trip to Singapore with 8 days notice. My passport was valid but expiring in 2 months. Fast Passport Center expedited a renewal and I had it in 3 days. Incredible for being so far from a passport agency.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Angela R.",
      location: "Holmen, WI",
      rating: 5,
      text: "Family cruise from Miami and both kids needed first-time passports. La Crosse Post Office was booked for weeks. Fast Passport Center handled all three — arrived in 5 days. Amazing service for Coulee Region families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Craig M.",
      location: "Sparta, WI",
      rating: 5,
      text: "Lost my passport during a move from La Crosse to Sparta. Had a flight to London in 6 days. Fast Passport Center replaced it in 48 hours. The courier to Chicago made all the difference — no way I was driving 10 hours roundtrip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "la-crosse-1",
      name: "La Crosse Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "425 State St",
      city: "La Crosse",
      state: "WI",
      zip: "54601",
      phone: "(608) 782-4995",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "Downtown La Crosse, near Riverside Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for the Coulee Region. Appointment required. Busy during UW-La Crosse study abroad seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "la-crosse-2",
      name: "La Crosse County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "400 4th St N, Room 1100",
      city: "La Crosse",
      state: "WI",
      zip: "54601",
      phone: "(608) 785-9580",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown La Crosse, county administration center",
      website: "https://www.lacrossecounty.org/",
      websiteLabel: "La Crosse County",
      notes: "County clerk passport acceptance. No photo services on-site. Good alternative to post office.",
      icon: "ri-government-line",
    },
    {
      id: "la-crosse-3",
      name: "Onalaska Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1205 Main St",
      city: "Onalaska",
      state: "WI",
      zip: "54650",
      phone: "(608) 783-2400",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 5 miles north of downtown La Crosse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Onalaska and Holmen residents. Often has better appointment availability than La Crosse locations.",
      icon: "ri-mail-line",
    },
    {
      id: "la-crosse-4",
      name: "Holmen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "312 Main St S",
      city: "Holmen",
      state: "WI",
      zip: "54636",
      phone: "(608) 526-9800",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 10 miles north of downtown La Crosse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern La Crosse County facility. Smaller office — call ahead for passport service hours.",
      icon: "ri-mail-line",
    },
    {
      id: "la-crosse-5",
      name: "Sparta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 N Water St",
      city: "Sparta",
      state: "WI",
      zip: "54656",
      phone: "(608) 269-2400",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 25 miles east of downtown La Crosse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Eastern La Crosse County and Monroe County facility. Convenient for Sparta and Tomah area residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5-hr drive to Chicago via I-90 (10-hr roundtrip)", fpc: "No — ship from La Crosse, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Coulee Region Business Travel", agency: "No special support for professionals", fpc: "Experienced with Coulee Region and Mississippi River valley business travelers" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "La Crosse residents are 300 miles from the nearest passport agency — further than almost any Wisconsin city. Routine processing takes 8–11 weeks. Coulee Region travelers should start expedited service at least 6 weeks before departure.",
    },
    {
      icon: "ri-car-line",
      title: "Driving to Chicago Without an Appointment",
      description: "At 300 miles each way from La Crosse, driving to the Chicago Passport Agency is a 10-hour roundtrip — and they'll turn you away without an appointment. Our courier service eliminates this entire wasted day.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo Specifications",
      description: "Retail photo services in the La Crosse area sometimes produce photos that fail State Department standards. Photos must be exactly 2x2 inches on a white background — no glasses, no smiling with teeth showing.",
    },
    {
      icon: "ri-file-list-line",
      title: "Mixing Up DS-82 and DS-11 Forms",
      description: "Coulee Region residents often grab the wrong form. DS-82 is only for adult renewals where you have your current passport in hand. Everything else requires DS-11 and an acceptance facility visit.",
    },
    {
      icon: "ri-calendar-line",
      title: "UW-La Crosse Study Abroad Timing",
      description: "Study abroad deadlines at UW-La Crosse typically fall in March (fall programs) and October (spring programs). La Crosse area acceptance facilities fill 3–4 weeks in advance during these periods. Plan accordingly.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Coulee Region travelers to Europe and Asia frequently discover this requirement too late — especially study abroad students.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in La Crosse or the Coulee Region." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx in the La Crosse area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Coulee Region documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — no 10-hour roundtrip needed." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your La Crosse address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in La Crosse, WI?", a: "Fast Passport Center offers emergency passport processing in La Crosse, Wisconsin in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St, Chicago) — no need to make the nearly 10-hour roundtrip drive yourself." },
    { q: "Does La Crosse have its own passport agency?", a: "No. Wisconsin has no regional passport agency. La Crosse is one of the furthest Wisconsin cities from a passport agency — the Chicago Passport Agency is approximately 300 miles southeast (about 5 hours via I-90). Fast Passport Center's courier service means Coulee Region residents never need to make that trip." },
    { q: "Can I use the Minneapolis Passport Agency from La Crosse?", a: "No. The Minneapolis Passport Agency only serves Minnesota residents. Even though it's about 150 miles from La Crosse (closer than Chicago's 300 miles), Wisconsin residents must use the Chicago Passport Agency. Fast Passport Center's courier service handles the Chicago delivery for you." },
    { q: "What airport do La Crosse travelers use?", a: "La Crosse Regional Airport (LSE) offers domestic connections. Most international travelers fly from Minneapolis-St. Paul (MSP, 150 miles northwest) or Chicago O'Hare (ORD, 300 miles southeast). A valid passport is required for all international connections." },
    { q: "How much does an expedited passport cost in La Crosse?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in La Crosse?", a: "Walgreens (multiple La Crosse locations including 2124 Rose St), CVS (2105 Ward Ave), and the UPS Store (315 3rd St S) all offer passport photo services. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve UW-La Crosse students?", a: "Yes. We serve all University of Wisconsin-La Crosse students, faculty, and staff. We handle study abroad passport needs, faculty conference travel, and student research programs with turnaround as fast as 24–48 hours." },
    { q: "What about Onalaska, Holmen, or Winona MN residents?", a: "Fast Passport Center serves all of the Coulee Region including La Crosse, Onalaska, Holmen, West Salem, Sparta, Tomah, Viroqua, and Prairie du Chien. While we process U.S. passports for Wisconsin residents, Winona, MN residents would need to use the Minneapolis Passport Agency path or contact us for Minnesota-specific guidance." },
  ],
  photoLocations: [
    { name: "Walgreens — La Crosse (Rose St)", address: "2124 Rose St, La Crosse, WI 54603", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — La Crosse (Ward Ave)", address: "2105 Ward Ave, La Crosse, WI 54601", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — La Crosse", address: "315 3rd St S, La Crosse, WI 54601", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Onalaska", address: "9400 State Rd 16, Onalaska, WI 54650", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "WI DMV — La Crosse", address: "333 Vine St, La Crosse, WI 54601", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Coulee Region DMV serving La Crosse County. REAL ID and driver's license renewals. Appointment recommended.", featured: true },
    { name: "WI DMV — Sparta", address: "1130 N Superior Ave, Sparta, WI 54656", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Monroe County DMV. Alternative for eastern La Crosse County residents.", featured: false },
  ],
  airports: [
    {
      code: "LSE",
      name: "La Crosse Regional Airport",
      distance: "5 miles north of downtown La Crosse, on French Island",
      address: "2850 Airport Rd, La Crosse, WI 54603",
      note: "La Crosse's regional airport with domestic service to major hubs including Chicago O'Hare and Minneapolis. International travelers connect through these hubs.",
      flightUrl: "https://www.lseairport.com/",
      flightLabel: "LSE Airport",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis-St. Paul International Airport",
      distance: "150 miles northwest of La Crosse — approximately 2.5 hours via I-90 and I-94",
      address: "4300 Glumack Dr, St Paul, MN 55111",
      note: "Primary international airport for Coulee Region travelers. Major Delta hub with extensive domestic and international routes across six continents.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "300 miles southeast of La Crosse — approximately 5 hours via I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub. Most La Crosse travelers prefer MSP for convenience, but ORD offers additional international route options.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "O'Hare Airport",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (WI DHS)", url: "https://www.dhs.wisconsin.gov/vitalrecords/", desc: "Wisconsin Department of Health Services — Vital Records Office for birth and death certificates statewide" },
    { label: "Marriage Licenses (La Crosse County Clerk)", url: "https://www.lacrossecounty.org/", desc: "La Crosse County Clerk for marriage licenses in La Crosse and La Crosse County" },
    { label: "Divorce Decrees (La Crosse County Circuit Court)", url: "https://www.wicourts.gov/courts/circuit/lacrosse.htm", desc: "La Crosse County Circuit Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Wisconsin vital records online via VitalChek" },
  ],
};